<template>
  <div>
    <div> <!-- :pagination.sync="pagination" :total-items="totalItems" -->
      <v-data-table :headers="headers" :items="people" hide-actions class="elevation-1"
            :loading="loading" noDataText="Searching...">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left pa-1">
              <router-link :to="{path: '/person/' + props.item.id}" target="_blank">
              {{ $prettyName(props.item.surname) }}, {{ $prettyName(props.item.firstNames) }}
              </router-link>
              <span v-if="props.item.updated" style='float:right;background:#ffff00;font-weight:bold;padding-right:1em'>
                {{ $dateShortFormatFromYMDTHM(props.item.updated) }}
                <span v-if="props.item.updatedBy">{{ props.item.updatedBy }}</span> 
              </span>
          </td>
          <td class="text-xs-left pa-2">{{ $renderSingleValues(props.item.service) }}</td>                   
          <td class="text-xs-left pa-2">{{ $renderStandardListNoLink(props.item.serviceNum) }}</td>                 

          <td class="text-xs-left pa-2" nowrap='nowrap'>{{ props.item.birthDate }}</td>
          <td class="text-xs-left pa-2" nowrap='nowrap'>{{ getEnlistDate(props.item.bio) }}</td>
          <td class="text-xs-left pa-2"> 
            <place-summary v-bind:place="props.item.addressAtEnlistment"></place-summary>
          </td>
          <td class="text-xs-left pa-2">
              <list-with-links v-bind:field="props.item.rank" fieldName="rank"></list-with-links>
          </td>
          <td class="text-xs-left pa-2">
            <list-with-links v-bind:field="props.item.unit" fieldName="unit"></list-with-links>
          </td>
          <td class="text-xs-left pa-2" nowrap='nowrap'>{{ props.item.pow }}</td>          
        </template>

        <template slot="no-data">
          <div v-if="(finalCount === 0)">
          <v-alert
            :value="true"
            color="error"
            icon="warning"
          >Nothing found :(</v-alert></div>
        </template>
      </v-data-table>
    </div>

    <div style='margin-top:10px;margin-bottom:10px'>           
      <v-btn  class="blue-grey lighten-3" @click='goto(0)' :disabled=isAtStart>Start</v-btn>  
      <v-btn  class="blue-grey lighten-3" @click='goto(-1)' :disabled=isAtStart>Prev</v-btn>  
      <v-btn  class="blue-grey lighten-3" @click='goto(1)' :disabled=isAtEnd>Next</v-btn>
      <v-btn  class="blue-grey lighten-3" @click='goto(2)' :disabled=endIsUnknownOrNotThere>End</v-btn>
    </div>

  </div>

</template>

<script>
import PeopleService from "@/services/PeopleService" ;
// import Panel from "@/components/Panel" ;
export default {
  components: {
    // Panel
  },
  props: {
  },
  data () {
    return {
      start: 0,
      limit: 15,
      surname: "",
      reportName: "",

      people: [ ],

      totalItems: 0,
      finalCount: -1,
      loading: true,
      pagination: {},

      headers: [
        { 
          text: "Name",
          align: "left",
          sortable: false,
          width: "30%",
          class: "pa-1"
        },
        { text: "Service", sortable: false, width: "8%", class: "pa-2" },
        { text: "Number", sortable: false, width: "8%", class: "pa-2" },
        { text: "Born", sortable: false, width: "1%", class: "pa-2" },
        { text: "Enlisted", sortable: false, width: "1%", class: "pa-12" },
        {
          text: "Address at enlist",
          sortable: false,
          width: "10%",
          class: "pa-2"
        },
        { text: "Final Rank", sortable: false, width: "10%", class: "pa-2" },
        { text: "Final Unit", sortable: false, width: "25%", class: "pa-2" },
        { text: "POW", sortable: false, width: "3%", class: "pa-2" }
      ]     
    };
  },
  async created () {
    // await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },  
  methods: {
    
    async goto (inc) {
      if (inc === 1) {
        if (this.finalCount < 0) this.start += this.limit ;
        else if ((this.start + this.limit) < this.finalCount) this.start += this.limit ;
      }
      else if (inc === -1) {
        this.start -= this.limit ;
        if (this.start < 0) this.start = 0 ;
      }
      else if (inc === 2) { // goto the end
        this.start = this.finalCount - this.limit ;
        if (this.start < 0) this.start = 0 ;
      }
      else this.start = 0 ;
      await this.readData() ;
    },

    async readData () {
      this.loading = true ;
      console.log("In read Data ERPT") ;
      // let search = this.search.trim().toLowerCase() ;
      // console.log("search " + search + " sortby " + sortBy + " descending " + descending + " page " + page + " rowsPerPage " + rowsPerPage) ;

      const result = await PeopleService.editorReports(this.reportName, this.surname, this.start, this.limit) ;

      this.people = result.data ;
      if (this.people.length < 1) { // at the end
        if (this.finalCount < 0) {
          this.finalCount = this.totalItems ;
          await this.goto(-1) ;
          return ;
        }
      }
      if (this.finalCount < 0) {
        if ((this.start >= this.totalItems)) this.totalItems += this.people.length ;
        console.log("  set  this.totalItems " + this.totalItems)
      }
      if (this.people.length < this.limit) { // we've tricked to the end
        console.log("set final count to " + this.totalItems)
        this.finalCount = this.totalItems ;
      }
      this.loading = false ;
      console.log("in getdatafrom api data len " + this.people.length + " this.finalCount =" + this.finalCount) ;
    },    

    getEnlistDate (bios) {
      if (!bios) return "" ;
      for (let bio of bios) {
        if (bio.beTemplateId === this.$constants.enlistedBioEntryId) return bio.date ;
      }
      return "" ;
    }
  },
  
  watch: {
  },
  async mounted () {
       
    if (this.$route.query) {
      const rq = this.$route.query ;
      this.surname = rq.surname ;
      this.reportName = rq.reportName ;
    }
    console.log("---------------------------------\nin ERPT mounted reportName=" + this.reportName + " surname=" + this.surname) ;

    await this.readData() ;
  },
  computed: { 
    isAtStart () {
      return (this.start < 1) ;
    },
    isAtEnd () {
      if (this.finalCount < 0) return false ;
      if ((this.start + this.limit) >= this.finalCount) return true ;
      return false ;
    },
    endIsUnknownOrNotThere () {
      if (this.finalCount < 0) return true ;
      if ((this.start + this.limit) >= this.finalCount) return true ;
      return false ;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EditorReportsPeopleTable.vue